import templateUrl from './loader.html';

export const loaderComponent = {
    bindings: {
        showTryAgainButton: '@',
        onTryAgain: '&'
    },

    templateUrl,

    controller: class LoaderComponent {
        constructor($parse, $timeout) {
            "ngInject";

            this.$parse = $parse;
            this.$timeout = $timeout;
        }

        $onInit() {
            this.timerForTryAgainOption = this.$timeout(() => {
                this._showTryAgainButton = this.$parse(this.showTryAgainButton || "false")(false);
            },10000);
        }

        $onDestroy() {
            this.$timeout.cancel(this.timerForTryAgainOption);
        }
     }
};


// WEBPACK FOOTER //
// ./src/app/common/components/loader/loader.component.js